export const dataProperties = {
  privacyPolicy: 'privacyPolicy',
};

export const privacyContentMaxLength = 10000;
